export default {
  grayHeader: 'お問い合わせ',
  overview:
    '星野リゾートに関する名称、画像素材を使ったキャンペーン等をご希望の方は以下フォームに詳細をご記入ください。\n担当者より素材の使用許可に関するご連絡を差し上げます。',
  company: {
    title: 'ご法人名：',
    placeholder: '株式会社星野リゾート'
  },
  name: {
    title: 'お名前：',
    placeholder: '星野 太郎'
  },
  telephone: {
    title: '電話番号：',
    placeholder: '08012345678'
  },
  email: {
    title: 'メールアドレス：',
    placeholder: 'taro@hoshinoresorts.com'
  },
  description: {
    title: 'お問い合わせ内容：',
    placeholder: 'お問い合わせ内容を入力'
  },
  submit: '送信する',
  completion: {
    gratitudeMessage: 'お問い合わせありがとうございました',
    notificationMessage1: 'お問い合わせを受け付けました。',
    notificationMessage2: 'お問い合わせいただきました内容を確認後、',
    notificationMessage3: '担当より改めてご連絡いたします。',
    backToTop: 'TOPに戻る'
  }
};



// WEBPACK FOOTER //
// ./src/i18n/ja/contact.js